import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

/** Use Intl for accurate UTC (Zulu) regardless of device timezone */
function formatUTC(d: Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    timeZone: 'UTC',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(d);
}

function formatLocal(d: Date): string {
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(d);
}

/**
 * Digital Flight Deck clock - Local + UTC (Zulu) in header.
 * Monospaced fonts, neon green glow for ZULU.
 */
export const GlobalClock: React.FC = () => {
  const [utc, setUtc] = useState('');
  const [local, setLocal] = useState('');

  useEffect(() => {
    const tick = () => {
      const now = new Date();
      setUtc(formatUTC(now));
      setLocal(formatLocal(now));
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const monoStyle = {
    fontFamily: "'JetBrains Mono', 'Roboto Mono', 'SF Mono', 'Consolas', monospace",
    fontWeight: 600,
    letterSpacing: '0.05em',
    fontVariantNumeric: 'tabular-nums' as const,
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        px: 1.5,
        py: 0.5,
        borderRadius: 1,
        bgcolor: 'rgba(0,0,0,0.25)',
        border: '1px solid rgba(0, 255, 65, 0.2)',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 0.25 }}>
        <Typography variant="caption" sx={{ ...monoStyle, fontSize: '0.75rem', color: '#00B8D4', textShadow: '0 0 8px rgba(0, 184, 212, 0.5)' }}>
          UTC {utc} Z
        </Typography>
        <Typography variant="caption" sx={{ ...monoStyle, fontSize: '0.75rem', color: '#00FF41', textShadow: '0 0 6px rgba(0, 255, 65, 0.4)' }}>
          Local {local}
        </Typography>
      </Box>
    </Box>
  );
};

export default GlobalClock;
